module.exports = __webpack_public_path__ + "static/img/Ellipse67.bcf77a03.png";